export default __webpack_public_path__ + "static/media/Account-Delete.fe719de7.jpg";